// extracted by mini-css-extract-plugin
module.exports = {"ChartHeader":"ChartHeader_ChartHeader__T/7i/","Title":"ChartHeader_Title__dkSg3","Line":"ChartHeader_Line__dJhOI","PrimaryArea":"ChartHeader_PrimaryArea__FJ2n4"};